import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDictionary } from '../interfaces/models/idictionary.model';
import { AppSettings } from '../models/appsettings';
import { EntityState } from '../models/enums';
import { DictionaryBaseService } from '../services/dictionary-base.service';
import { EventsService } from '../services/events.service';
import { UserContextService } from '../services/user-context.service';
import { ModelFormComponent } from './model-form-base.component';

@Component({
    template: '',
    standalone: false
})
export abstract class DictionaryFormComponent<
  T extends IDictionary
> extends ModelFormComponent<T> {
  model: T = { Id: 0 } as T;
  suggestionsRowsPerDdl: number = AppSettings.suggestionsRowsPerDdl;

  constructor(
    protected events: EventsService,
    protected modelSvc: DictionaryBaseService<T>,
    protected userContextSvc: UserContextService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location
  ) {
    super(events, modelSvc, userContextSvc, route, router, location);
  }

  ngOnInit() {
    let queryBFStr = this.route.snapshot.queryParamMap.get('bf');
    if (
      queryBFStr &&
      this.userContextSvc.currentUser.SelectedBF?.Id !== Number(queryBFStr) &&
      !this.userContextSvc.currentUser.isTaskScopedContext
    ) {
      this.router.navigate(['/sbf'], {
        queryParams: {
          id: queryBFStr,
          locationBack: window.location.href,
        },
      });
    }
    super.ngOnInit();
  }

  saveModel(): Promise<any> {
    if (this.loading) {
      return this.getNullResolvedPromise();
    }
    let validation = this.modelSvc.validate(this.model);
    if (!validation.Valid) {
      this.showWarningMessage('Сохранение', validation.Message);
      return this.getNullResolvedPromise();
    }
    this.loading = true;
    return this.modelSvc
      .save([this.model])
      .toPromise()
      .then((x) => {
        this.model.Id = x[0].Id;
        this.model.State = EntityState.View;
        return Promise.resolve(x[0]);
      })
      .catch((err) => {
        this.loading = false;
        this.showExceptionMessage('Сохранение', err);
        return Promise.reject(err);
      });
  }

  handleLoadModelSuccess(res: T) {
    // override parent method
    this.model = res;
    this.model.State = undefined;
    this.isAuthor = res.CreatedById == this.userContextSvc.currentUser.Id;
    this.onInitialDataLoadingComplete();
    return Promise.resolve(res);
  }
}
